
export const role = {
    admin: "Administrador",
    mantainer: "Mantenedor",
    user: "Usuário"
}